// extracted by mini-css-extract-plugin
export default {"EmojiReactions":"EmojiReactions_EmojiReactions__GoYFc","EmojiIcon":"EmojiReactions_EmojiIcon__COCIf","Disabled":"EmojiReactions_Disabled__fs98N"};